import { createContext, useContext } from 'react';

/**
 * Signals that a control is rendered inside a `NotionFormSheet` property
 * row, so composite controls that own their own chrome — `PhoneInput`, the
 * `LocationSelect` cascade trigger, `ProjectMemberPicker`, etc. — drop their
 * border/background and adopt the calm borderless "Notion field" look (value as
 * plain text, no box in any state) to match the surrounding rows.
 *
 * Plain `input` / `textarea` / Radix `Select` triggers are handled by descendant
 * selectors on the row's value cell and do NOT need this context — it exists
 * only for widgets whose chrome lives on a wrapper the selectors can't reach.
 *
 * Defaults to `false`, so the very same widgets keep their normal bordered
 * chrome everywhere outside a NotionFormSheet.
 */
export const NotionFieldContext = createContext(false);

/** True when the current control is inside a NotionFormSheet property row. */
export function useNotionField(): boolean {
  return useContext(NotionFieldContext);
}
